import React from 'react';
import { GlobalFilterState } from '../GlobalFilterState';
import { RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { Calendar, CalendarProps, MultiViewCalendar, MultiViewCalendarProps } from '@progress/kendo-react-dateinputs';
import { DateTimeFieldPicker } from './DateTimeFieldPicker';
import { CPS_FIELD_TYPE } from '@cs-cms/types';

interface UnifiedCalendarProps {
  dateFiltersState: GlobalFilterState[];
  fieldSelected: GlobalFilterState;
  handleFieldChange: (event: RadioButtonChangeEvent) => void;
  calendarProps: CalendarProps | MultiViewCalendarProps;
}

export const UnifiedCalendar: React.FC<UnifiedCalendarProps> = props => {
  const { dateFiltersState, fieldSelected, handleFieldChange, calendarProps } = props;
  const selectedDate = calendarProps.value;
  const onSelectedDateChange = calendarProps.onChange;

  return (
    <div className="dateTimeCalendar">
      <DateTimeFieldPicker
        dateFiltersState={dateFiltersState}
        fieldSelected={fieldSelected}
        handleFieldChange={handleFieldChange}
      />

      {fieldSelected.type === CPS_FIELD_TYPE.DATETIME ? (
        <Calendar
          value={selectedDate as CalendarProps['value']}
          onChange={onSelectedDateChange as CalendarProps['onChange']}
        />
      ) : (
        <MultiViewCalendar
          value={selectedDate as MultiViewCalendarProps['value']}
          onChange={onSelectedDateChange as MultiViewCalendarProps['onChange']}
        />
      )}
    </div>
  );
};
